<template>
  <div>
    <v-card class="main pa-2">
      <v-toolbar dense flat>
        <v-toolbar-title class="body-2 beez-bold">
          Fix User Sync-Up issues
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            :loading="syncUploader"
            flat
            icon
            @click="refreshSyncUP"
          >
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            :loading="syncUploader"
            flat
            icon
            @click="fixAllIssues"
          >
            <v-icon>
              build
            </v-icon>
          </v-btn>
          <span>Fix All Issues</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="search"
          color="secondary"
          label="Search for User Name"
          @change="refreshSyncUP"
        >
        </v-text-field>
        <v-data-table
          :headers="headers"
          :items="syncUpStatus"
          :loading="syncUploader"
          :pagination.sync="pagination"
          :rows-per-page-items="headerPageItems"
          :total-items="pagination.totalItems"
          item-key="userHexId"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.userHexId }}</td>
              <td class="text-xs-left">{{ props.item.userName }}</td>
              <td class="text-xs-left">{{ props.item.createdAtLocal }}</td>
              <td>
                <v-icon :color="props.item.camundaUser ? '#42a85f' : '#b82e24'"
                  >{{ props.item.camundaUser ? 'thumb_up' : 'thumb_down' }}
                </v-icon>
              </td>
              <td>
                <v-icon
                  :color="props.item.tulipIdentity ? '#42a85f' : '#b82e24'"
                  >{{ props.item.tulipIdentity ? 'thumb_up' : 'thumb_down' }}
                </v-icon>
              </td>
              <td>
                <v-icon
                  :color="props.item.camundaSyncUp ? '#42a85f' : '#b82e24'"
                  >{{ props.item.camundaSyncUp ? 'thumb_up' : 'thumb_down' }}
                </v-icon>
              </td>
              <td class="text-xs-left">
                <v-btn icon @click.stop="fixSyncUpIssue(props.item)">
                  <v-icon>build</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SyncUpFix',
  data() {
    return {
      syncUploader: false,
      search: '',
      currentPage: 0,
      rowsPerPage: 0,
      descending: false,
      sortBy: '',
      headerPageItems: [5, 10, 25],
      pagination: {
        sortBy: 'createdAt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headers: [
        {
          text: 'User ID',
          align: 'left',
          value: 'userHexId',
          sortable: false
        },
        { text: 'User Name', value: 'userName' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Workflow Engine Account', value: 'camundaUser' },
        { text: 'Workflow Engine Identity', value: 'tulipIdentity' },
        { text: 'Workflow Engine Sync-Up', value: 'camundaSyncUp' },
        { text: 'Fix', value: 'userHexId' }
      ]
    }
  },
  computed: {
    ...mapState({
      syncUpStatus: state => state.honeyUsers.syncUpStatus,
      totalUsers: state => state.honeyUsers.totalUsers
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refreshSyncUP()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    },
    totalUsers() {
      this.pagination.totalItems = this.totalUsers
    }
  },
  mounted() {
    this.refreshSyncUP()
  },
  methods: {
    async refreshSyncUP() {
      this.syncUploader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.search) {
        urlParams = urlParams + `&username=${this.search}`
      }
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      try {
        await this.$store.dispatch('getUserCount', urlParams)
        await this.$store.dispatch('fetchSyncUpStatus', urlParams)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to get Sync-Up status',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncUploader = false
    },
    async fixAllIssues() {
      this.syncUploader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.search) {
        urlParams = urlParams + `&username=${this.search}`
      }
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      try {
        await this.$store.dispatch('getUserCount', urlParams)
        await this.$store.dispatch('fixALLTulipUser', urlParams)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fix Sync-Up issues',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncUploader = false
    },
    async fixSyncUpIssue(item) {
      this.syncUploader = true
      try {
        await this.$store.dispatch('fixTulipUser', item.userHexId)
        await this.refreshSyncUP()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fix Sync-Up issues for User: ' + item.username,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncUploader = false
    }
  }
}
</script>

<style scoped></style>
